module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#pause",
      toString: function () {
        return this.url;
      }
    }